import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/main-logo.svg';
import { Routes } from '../../constants/RouteConstants';
import Button from '../../components/ui/Button';
import useMakeRequest from '../../utils/ApiHelper';
import toast from 'react-hot-toast';
import { ApiConstants } from '../../constants/ApiConstants';
import { OtpVerifyTypes } from '../../constants/Constants';
import CustomInput from '../../components/ui/CustomInput'; // Add this import

const ForgotPassword = () => {
  const navigate = useNavigate();
  const forgotPassword = useMakeRequest();

  const [mail, setMail] = useState('');
  const [validMail, setValidMail] = useState<null | boolean>(null);
  const [loading, setLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState<number | undefined | any>(undefined);

  const checkMail = (mail: string) => {
    setMail(mail);
    setValidMail(null);
    setLoading(true);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const timeout = setTimeout(() => {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(mail)) {
        setValidMail(true);
      } else {
        setValidMail(false);
      }
      setLoading(false);
    }, 500);
    setTypingTimeout(timeout);
  };

  const handleSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (validMail) {
      toast.promise(
        forgotPassword.makeRequest({ payload: { email: mail }, url: ApiConstants?.ForgotPassword }),
        {
          loading: 'Processing...',
          success: (data: any) => data.message,
          error: (error: any) => error.message,
        })
    }
  };

  useEffect(() => {
    if (forgotPassword?.status) {
      navigate(Routes?.Otp, { state: { email: mail, verifyType: OtpVerifyTypes?.FORGOT_PASSWORD } })
    } else {
      navigate(Routes?.ForgotPassword, { state: { email: null } })
    }
  }, [forgotPassword?.status]);

  return (
    <>
      <main id="main-content" className="auth-page forgot-password-page">
        <div className="auth-container">
          <h1 className='auth-title'>Forgot Password</h1>
          <p className='auth-sub-para'>Enter your registered email address to
            receive a verification code.</p>

          <form onSubmit={handleSubmit} className='auth-form-wrap'>
            <div className="auth-form">
              <div className="auth-form-fields">
                <CustomInput
                  label="Email"
                  type="email"
                  placeholder="Enter email"
                  required
                  value={mail}
                  onChange={(e) => checkMail(e.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      handleSubmit();
                    }
                  }}
                  icon={
                    loading ? (
                      <span className='spinner-border spinner-border-sm text-primary border-1' role="status"></span>
                    ) : validMail === true ? (
                      <i className='icon-tick'></i>
                    ) : validMail === false ? (
                      <i className="text-danger fa fa-times-circle" aria-hidden="true"></i>
                    ) : null
                  }
                />
              </div>

              <div className="auth-form-actions">
                <Button
                  className='com-btn'
                  type="submit"
                  disabled={!validMail || loading}
                  loading={forgotPassword?.loading}
                >
                  Next
                </Button>
              </div>
            </div>
          </form>
        </div>
      </main>
    </>
  );
};

export default ForgotPassword;